<admin-page-second [title]="'pages.results.cases.title' | translate">

  <admin-section-standard [title]="'pages.results.cases.title' | translate">
    <admin-panel-empty>
      <admin-results-case-form></admin-results-case-form>
    </admin-panel-empty>

    <div class="pb-5"></div>

    <admin-results-case-list></admin-results-case-list>
  </admin-section-standard>

</admin-page-second>
